
// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import Api from '@/services/api';
import AppService from '@/services/app';

// --- Third Party ---
import Hashids from 'hashids';
import StarRating from 'vue-star-rating';

@Component({
  components: {
    StarRating,
  },
})
export default class Accommodation1Listing extends Vue {
  hashids = new Hashids(process.env.VUE_APP_HASHIDS_SALT);

  surveyId: number = 0;

  surveyData: any = {
    location: '',
    email: '',
    question_1: '',
    question_2: [],
    comment_2: '',
    question_3: '',
    question_4: [],
    question_5: 3,
    question_6: 3,
    comment_6: '',
    question_7: 3,
    question_8: 3,
    question_9: 3,
    comment_9: '',
    question_10: 3,
    question_11: 3,
    comment_11: '',
    question_12: 3,
    comment_12: '',
    question_13: 3,
    question_14: 3,
    question_15: 3,
    question_16: 3,
    comment_16: '',
    question_17: 3,
    comment_17: '',
    feedback: '',
  };

  async beforeMount() {
    // id: 1 = Ap
    const surveyIdStr: string = this.hashids.decode(this.$route.params.id) + '';

    if (surveyIdStr && surveyIdStr.length > 0) {
      this.surveyId = parseInt(surveyIdStr, 10);

      await this.getSurvey();
    } else {
        // kick  them out, how did they even get here?!
        this.$router.push({ path: '/error'});
      }
  }

  async getSurvey() {
      try {
        const response = await Api(true).get(this.$route.fullPath.substring(0, this.$route.fullPath.indexOf(this.$route.params.id) - 1), { params: { id: this.surveyId }});

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
            // kick them out, we have no survey for this Id
            this.$router.push({ path: '/error'});
          } else {
            this.surveyData = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {

        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('Accommodation_1.vue - getSurvey - 729 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
        
        // kick  them out, we have no survey for this Id
        this.$router.push({ path: '/error'});
      }
    }
}
